export const useStyles = theme => ({
  headerTitle: {
    color: '#303030',
    textTransform: 'unset',
    fontSize: '36px',
    marginRight: '20px',
    lineHeight: '1 !important',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '26px',
      marginBottom: '10px',
    },
  },
  headingTitle: {
    fontSize: '20px',
    fontWeight: '300',
    marginBottom: '-0.2em',
  },
  titleRoot: {
    display: 'flex',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '20px',
      display: 'block',
    },
  },
});
